import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30rem;
`;

export const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${respondTo.smallTablet`
    flex-direction: column;
    gap: 20rem;
  `}

  ${respondTo.smallPhone`
    gap: 15rem;
  `}
`;

export const InputWrapper = styled.div`
  width: 400rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}

  ${respondTo.smallPhone`
    width: 100%;
  `}
`;

export const CTAButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 15rem;
  `}
`;

export const SelectWrapper = styled.div`
  width: 200rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

export const CompaniesWrapper = styled.div`
  display: grid;
  grid-gap: 30rem;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 300rem);

  ${respondTo.horizontalTablet`
    grid-template-columns: repeat(
      auto-fill,
      30%
    );
  `}

  ${respondTo.bigPhone`
    grid-template-columns: repeat(
      auto-fill,
      46%
    );

    grid-gap: 15rem;
  `}

  ${respondTo.smallPhone`
    grid-template-columns: repeat(
      auto-fill,
      100%
    );
  `}
`;

export const NoContentLabel = styled.label`
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;

export const NoContentLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
